// src/services/api.js
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const registerAdmin = async (adminData) => {
  try {
    const response = await fetch(`${API_BASE_URL}/signup`, {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        'Accept': 'application/json' // Add this!
      },
      body: adminData,
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Registration failed');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};

// You can add other API calls here later

export const loginUser = async (loginData) => {
    try {
      const response = await fetch(`${API_BASE_URL}/signin`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        body: JSON.stringify(loginData),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Login failed');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };

  export const fetchUsers = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/users`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch users');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };

  export const fetchUserById = async (id, token) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/${id}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch user');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
  export const fetchUserBalance = async (userId, password, token) => {
    try {
      const response = await fetch(`${API_BASE_URL}/user/${userId}/check-balance`, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ password }),
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch balance');
      }
  
      return await response.json(); // { balance: 1234.50 }
    } catch (error) {
      throw error;
    }
  };
  
  export const fetchTopupUser = async (receiverId) => {
    try {
      const response = await fetch(`${API_BASE_URL}/wallet/topup?user=${receiverId}`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('adminToken')}`
        }
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to fetch user for topup');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
  
  export const sendWalletPayment = async (paymentData) => {
    try {
      const token = localStorage.getItem('adminToken');
  
      const response = await fetch(`${API_BASE_URL}/wallet/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(paymentData)
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Payment failed');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };


  export const addFunds = async ({ user_id, amount }) => {
    try {
      const token = localStorage.getItem('adminToken');
  
      const response = await fetch(`${API_BASE_URL}/wallet/add-funds`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ user_id, amount })
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Add funds failed');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
  export const fetchTransactions = async (params = {}) => {
    const token = localStorage.getItem('adminToken');
  
    // Default page = 1
    const {
      page = 1,
      search = '',
      type = '',
      status = '',
      from_date = '',
      to_date = '',
    } = params;
  
    // Build query string dynamically
    const query = new URLSearchParams({
      page,
      search,
      type,
      status,
      from_date,
      to_date,
    }).toString();
  
    const response = await fetch(`${API_BASE_URL}/transactions?${query}`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch transactions');
    }
  
    return await response.json();
  };
  

  export const fetchRecentWalletTransactions = async () => {
    const token = localStorage.getItem('adminToken');
    const response = await fetch(`${API_BASE_URL}/wallet-transactions`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch wallet transactions');
    }
  
    return await response.json();
  };

  export const updateUser = async (id, userData) => {
    const token = localStorage.getItem('adminToken');
    try {
      const response = await fetch(`${API_BASE_URL}/user/${id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(userData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Update failed');
      }
      
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
  
  export const deleteUser = async (id) => {
    const token = localStorage.getItem('adminToken');
  
    try {
      const response = await fetch(`${API_BASE_URL}/user/${id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });
  
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Delete user failed');
      }
  
      return await response.json();
    } catch (error) {
      throw error;
    }
  };
  


  export const fetchDashboardStats = async () => {
    const token = localStorage.getItem('adminToken');
  
    const response = await fetch(`${API_BASE_URL}/dashboard-stats`, {
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    });
  
    if (!response.ok) {
      throw new Error('Failed to fetch dashboard stats');
    }
  
    return await response.json();
  };
  
  // New chart APIs 📊// 📈 Monthly User Stats
export const fetchMonthlyUserStats = async () => {
  const token = localStorage.getItem('adminToken');

  const response = await fetch(`${API_BASE_URL}/monthly-users`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch monthly user stats');
  }

  return await response.json();
};

// 💳 Monthly Transaction Stats
export const fetchMonthlyTransactions = async () => {
  const token = localStorage.getItem('adminToken');

  const response = await fetch(`${API_BASE_URL}/monthly-transactions`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch monthly transaction stats');
  }

  return await response.json();
};


export const fetchTransactionTypeBreakdown = async () => {
  const token = localStorage.getItem('adminToken');

  const response = await fetch(`${API_BASE_URL}/transaction-type-breakdown`, {
    headers: {
      'Accept': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Failed to fetch transaction type breakdown');
  }

  return await response.json();
};


export const fetchUserTransactions = async (userId, token) => {
  try {
    const response = await fetch(`${API_BASE_URL}/user/${userId}/transactions`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch transactions');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};



// 👥 1️⃣ Fetch recent people you transact with
export const fetchRecentPeople = async (userId) => {
  const token = localStorage.getItem('adminToken');

  try {
    const response = await fetch(`${API_BASE_URL}/wallet/people/${userId}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch people list');
    }

    return await response.json(); // → [{id, name, email}, ...]
  } catch (error) {
    console.error('Error fetching people:', error);
    throw error;
  }
};



// 💬 2️⃣ Fetch chat-style transaction history between two users
export const fetchChatHistory = async (userId, partnerId) => {
  const token = localStorage.getItem('adminToken');

  try {
    const response = await fetch(
      `${API_BASE_URL}/wallet/chat-history/${userId}/${partnerId}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch chat history');
    }

    return await response.json(); // → [{id, type: 'sent'|'received', amount, date}]
  } catch (error) {
    console.error('Error fetching chat history:', error);
    throw error;
  }
};


export const fetchVendors = async () => {
  const token = localStorage.getItem('adminToken');
  try {
    const response = await fetch(`${API_BASE_URL}/vendors`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch vendors');
    }

    const result = await response.json();
    return result.data; // IMPORTANT
  } catch (error) {
    throw error;
  }
};


export const fetchAllUsers = async () => {
  const token = localStorage.getItem('adminToken');
  try {
    const response = await fetch(`${API_BASE_URL}/allUsers`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Authorization': `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Failed to fetch users');
    }

    return await response.json();
  } catch (error) {
    throw error;
  }
};


// 📧 Forgot Password - Send Reset Link
export const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${API_BASE_URL}/forgot-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.message ||
        result.errors?.email?.[0] ||
        'Failed to send reset link'
      );
    }

    return result;
  } catch (error) {
    throw error;
  }
};


// 🔐 Reset Password
export const resetPassword = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(
        result.message ||
        result.errors?.email?.[0] ||
        'Password reset failed'
      );
    }

    return result;
  } catch (error) {
    throw error;
  }
};


export const exportTransactionsPdf = (params) => {
  const query = new URLSearchParams(params).toString();
  window.open(
    `${API_BASE_URL}/transactions/export-pdf?${query}`,
    "_blank"
  );

};

